
import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { UserViewModel } from "../../models/user-view-model";
import { UserManagementService } from "../../services/user-management.service";
import { RegisterResultViewModel } from "../../models/register-result-view-model";
import { ParticipantRoleAndPermissionsViewModel } from "../../models/participant-role-and-permissions-view-model";
import { Select2OptionData } from "ng-select2";
import { UserDataStoreService } from '../../services/user-data-store.service';
import { PermissionEnum } from '../../services/guards/permissions';
import { ToastrService } from 'ngx-toastr';
import { ParticipantViewModel } from '../../models/participant-view-model';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { ParticipantService } from "../../services/participant.service";
import { AuthenticationService } from "../../services/authentication.service";
import { async } from '@angular/core/testing';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import Callback = JQuery.Deferred.Callback;
import { Observable } from "rxjs";
import { LoggedInUser } from "../../models/user";

@Component({
  selector: 'app-user-view',
  templateUrl: './user-view.component.html',
  styleUrls: ['./user-view.component.scss']
})
export class UserViewComponent implements OnInit {

  public currentUser: Observable<LoggedInUser>;
  private _altronEmailDomains: string[] = [
    '@its.com'
  ];

  public user: UserViewModel = {
    email: '',
    name: '',
    lastName: '',
    phoneNumber: '',
    roles: [],
    participants: [],
    accountType: 1
  };
  public registerResult: RegisterResultViewModel;
  public allRoles: Select2OptionData[];
  public allParticipants: Select2OptionData[];

  public canEdit: boolean;
  public canAdd: boolean;
  public canActivate: boolean;
  public canDelete: boolean;
  public userInactivate: boolean;
  public selectedRoles: string[] = [];
  public selectedParticipants: string[] = [];
  public select2options: any = {
    multiple: true,
    width: '100%'
  };

  constructor(private _modal: NgbActiveModal, private _userManagementService: UserManagementService, private _authenticationService: AuthenticationService,
    private _userDataStore: UserDataStoreService, private _toastService: ToastrService, private _ngxUiLoaderService: NgxUiLoaderService,
    private _participantService: ParticipantService) {
    this.currentUser = _userDataStore.currentUser;
    this.canEdit = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditUser], []);
    this.canDelete = this._userDataStore.hasRequiredPermissions([PermissionEnum.DeleteUser], []);
    this.canAdd = this._userDataStore.hasRequiredPermissions([PermissionEnum.AddUser], []);
  }

  public async ngOnInit(): Promise<void> {
    
    const roles = (await this._authenticationService.GetParticipantRolesAndPermissions({ skip: 0, take: 1000 })).response;
    const participants = await this._userDataStore.userParticipants;

    this.allRoles = roles.map((value: ParticipantRoleAndPermissionsViewModel) => {
      return {
        id: value.role.id,
        text: value.role.name
      }
    });

    this.allParticipants = participants.map((value: ParticipantViewModel) => {
      return {
        id: value.id.toString(),
        text: value.name + ' (' + value.id.toString() + ')'
      }
    });


    if (!!this.user?.id) {
      setTimeout(async () => {

        if (!!this.user) {
          if (this.user.roles == null || this.user.participants == null) {
            this.user = await this._userManagementService.GetByUserId(this.user.id);
            this.selectedRoles = this.user.roles.map((x) => { return x.id });
            this.selectedParticipants = this.user.participants.map((pId) => pId.toString());
          }
          else {
            this.selectedRoles = this.user.roles.map((x) => { return x.id });
            this.selectedParticipants = this.user.participants.map((pId) => pId.toString());
          }

          //Set ResendActivation Link

          if (!this.user.isActive) {
            this.userInactivate = true;
          }

        }
      });

      this.canActivate = true;
    }
    else {
      //hide the activate button
      this.canActivate = false;
      this.canDelete = false;
      this.userInactivate = false;
    }
  }

  public async save(): Promise<void> {

    this._ngxUiLoaderService.start();
    this.user.roles = [];
    for (const role of this.selectedRoles) {
      this.user.roles.push(this.allRoles.find(x => x.id == role));
    }
    this.user.participants = [];
    for (const participant of this.selectedParticipants) {
      this.user.participants.push(+this.allParticipants.find(x => x.id.toString() == participant.toString()).id);
    }


    if (!this.user.id) {
      if (!this.canAdd) {
        this._toastService.error("You do not have the required permissions to perform this action.", "Error");
      }
      this.registerResult = await this._userManagementService.AddNewParticipantUser(this.user);
    } else {
      if (!this.canEdit) {
        this._toastService.error("You do not have the required permissions to perform this action.", "Error");
      }
      this.registerResult = await this._userManagementService.UpdateParticipantUser(this.user);
    }
    if (this.registerResult.success) {
      if (!this.user.id) {
        this._toastService.success(this.registerResult.message, "User created successfully");
        this.clearData();
      }
      else {
        this._toastService.success(this.registerResult.message, "User updated successfully");
        this._modal.close();
      }
    } else {
      this._toastService.error(this.registerResult.message, "Error");
    }
    this._ngxUiLoaderService.stop();
  }

  public async toggleActiveStatus(): Promise<void> {
    this.user.isActive = !!this.user.isActive ? 0 : 1;
    await this.save();
  }

  public async delete(): Promise<void> {
    if (!this.canDelete) {
      this._toastService.error("You do not have the required permissions to perform this action.", "Error");
    } else {

      var continueDelete = confirm("Are you sure you want to delete this user?");
      if (continueDelete == true) {
        this._ngxUiLoaderService.start();


        this.user.roles = [];
        for (const role of this.selectedRoles) {
          this.user.roles.push(this.allRoles.find(x => x.id == role));
        }


        if (this.user.isActive == 1) {
          this._toastService.error("User is currently active, please deactivate user before deleting.", "Error");
        }
        else {
          this.registerResult = await this._userManagementService.DeleteParticipantUser(this.user);

          if (this.registerResult.success) {
            this._toastService.success("User succefully deleted", "Success");
            this._modal.close();
          }
        }

        this._ngxUiLoaderService.stop();

      }
    }
  }

  public clearData(): void {
    this.user = {
      email: '',
      name: '',
      lastName: '',
      phoneNumber: '',
      roles: [],
      participants: [],
      accountType: 1
    };
    this.selectedRoles = [];
    this.selectedParticipants = [];
  }

  public close() {
    this._modal.close();
  }

  public toggleSuperUser(value) {
    this.isSuperUser = value;
  }

  public get isSuperUser() {
    if (!!this.user) {
      return this.user.accountType == 0;
    }
  }

  public set isSuperUser(value) {
    if (!!this.user) {
      if (!!value) {
        this.user.accountType = 0;
      } else {
        this.user.accountType = 1;
      }
    }
  }

  public async showSuperUserToggle() {
    const user = await this._userDataStore.currentUser.toPromise();
    return user.accountType === 1 &&
      user.email.split('@').length > 1 &&
      this._altronEmailDomains.includes(user.email.split('@')[1]);
  }

  public async resendActivationEmail(): Promise<void> {

    var emailSend = await this._userManagementService.SendActivationEmail(this.user);

    if (emailSend.success) {
      this._toastService.success(emailSend.message, "Success");
      this._modal.close();
    }
    else {
      this._toastService.error(emailSend.message, "Error");
    }
  }
}
